/** Adding a new mode requires matching it in tiles.wgsl `pickVizValue`
 *  (one extra branch). VIZ_MODES order must stay aligned with the
 *  shader's mode-id switch. */
type VizSource = "temp" | "hp" | "emissivity";

interface VizMode {
  readonly id: number;
  readonly key: string;
  readonly label: string;
  readonly source: VizSource | null;
  readonly rangeLo: number;
  readonly rangeHi: number;
}

export const VIZ_MODES: readonly VizMode[] = [
  { id: 0, key: "natural",    label: "NATURAL",    source: null,         rangeLo: 0,   rangeHi: 1    },
  { id: 1, key: "temp",       label: "TEMP",       source: "temp",       rangeLo: 290, rangeHi: 2500 },
  { id: 2, key: "hp",         label: "HP %",       source: "hp",         rangeLo: 0,   rangeHi: 1    },
  { id: 3, key: "emissivity", label: "EMISSIVITY", source: "emissivity", rangeLo: 0,   rangeHi: 1    },
];

const VIZ_DEFAULT = VIZ_MODES[0];

interface VizState {
  mode: VizMode;
}

export const vizState: VizState = {
  mode: VIZ_DEFAULT,
};

export function setVizMode(key: string): void {
  const next = VIZ_MODES.find((m) => m.key === key);
  if (next) vizState.mode = next;
}

export function isNatural(): boolean {
  return vizState.mode.id === 0;
}
